import { dayjs } from '@encarpkg/shared';
import { testEmail, testSalesNumber, testId, testMobile, testName, testNumber, testTel, testKor } from 'app/libs/regEx';
import { MEMBER_BIRTH_FORM_DATE_FORMAT } from 'app/constants/date';

const passwordCheck = (password) => {
	let flag = false;
	const alpha = 'abcdefghijklmnopqrstuvwxyz';
	const ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const Digit = '1234567890';
	const specialChar = '~!@#$%^&*()_+|';
	let value_alpha = 0;
	let value_ALPHA = 0;
	let value_digit = 0;
	let value_specialChar = 0;
	let value_invalid = 0;

	for (let i = 0; i < password.length; i += 1) {
		const ch = password.charAt(i);

		if (alpha.indexOf(ch) > -1) {
			value_alpha = 1;
		} else if (ALPHA.indexOf(ch) > -1) {
			value_ALPHA = 1;
		} else if (Digit.indexOf(ch) > -1) {
			value_digit = 1;
		} else if (specialChar.indexOf(ch) > -1) {
			value_specialChar = 1;
		} else {
			value_invalid = 1;
		}
	}

	const totalCnt = value_alpha + value_ALPHA + value_digit + value_specialChar;

	if (totalCnt < 2) {
		flag = false;
	} else if (totalCnt === 2 && password.length < 10) {
		flag = false;
	} else {
		flag = !(totalCnt > 2 && password.length < 8);
	}
	if (password.length > 16) {
		flag = false;
	}
	if (value_invalid > 0) {
		flag = false;
	}
	return flag;
};

export const getNameInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '이름을 입력해주세요.';
	if (!testName(value)) return '영문 또는 한글만 입력할 수 있습니다.';
	return '';
};

export const getEmailInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '이메일을 입력해주세요.';
	if (!testEmail(value)) return '이메일 형식이 올바르지 않습니다.';
	return '';
};

export const getIdInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '아이디를 입력해주세요.';
	if (testNumber(value[0])) return '아이디의 첫글자에는 숫자를 쓰실수 없습니다.';
	if (value && value.length < 4) return '아이디는 최소 4자 이상 입력하셔야 합니다.';
	if (value && testKor(value)) return '아이디는 영문, 숫자만 입력 가능합니다.';
	if (!testId(value)) return '영소문자+숫자를 조합하여 4~12자리까지 입력하실 수 있습니다.';
	return '';
};

export const getPhoneInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '휴대전화번호를 입력해주세요.';
	if (value && value.length < 10) return '번호 형식이 올바르지 않습니다.';
	if (!testMobile(value)) return '번호 형식이 올바르지 않습니다.';
	return '';
};

export const getTelInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '전화번호를 입력해주세요.';
	if (value && (value.length < 9 || value.length > 12)) return '번호 형식이 올바르지 않습니다.';
	if (value && (!testNumber(value) || !testTel(value))) return '번호 형식이 올바르지 않습니다.';
	return '';
};

export const getCodeInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '인증번호를 입력해주세요.';
	return '';
};

export const getGenderInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '성별을 선택해주세요.';
	return '';
};

export const getBirthInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '생년월일을 입력해주세요.';
	if (value && !testNumber(value)) return '숫자만 입력해주세요.';
	if (value && value.length !== 8) return '생년월일 8자리를 입력해주세요.';
	if (value[0]?.toString() === '0' || !dayjs(value, MEMBER_BIRTH_FORM_DATE_FORMAT, true).isValid()) return '유효한 생년월일을 입력해주세요.';
	if (value && dayjs(value).isBefore(dayjs().subtract(100, 'year'))) return '유효한 생년월일을 입력해주세요.';
	if (value && dayjs(value).isAfter(dayjs().add(-14, 'years'))) return '만 14세 이상부터 가입할 수 있습니다.';
	return '';
};

export const getLocationInvalidMessage = (sido, sigungu, isRequired = true) => {
	if (isRequired && (!sido || !sigungu)) return '거주지를 선택해주세요.';
	return '';
};

export const getPasswordInvalidMessage = (value, id, isRequired = true) => {
	if (value.length > 16) return '비밀번호 입력값이 초과되었습니다.';
	if (isRequired && !value) return '비밀번호를 입력해주세요.';
	if (value && !passwordCheck(value)) return '비밀번호 조합 형식에 맞춰 입력해 주세요.';
	if (id && value && value.indexOf(id) > -1) return '회원 아이디와 비밀번호를 같이 쓰실수 없습니다.';
	return '';
};

export const getPasswordConfirmInvalidMessage = (password, passwordConfirm) => {
	if (password && !passwordConfirm) return '비밀번호를 입력해주세요.';
	if (password !== passwordConfirm) return '비밀번호가 일치하지 않습니다.';
	return '';
};

export const getAddressInvalidMessage = (zipCode, address, detailAddress, isRequired = true) => {
	if (isRequired && (!zipCode || !address || !detailAddress)) return '주소를 입력해주세요.';
	return '';
};

export const getAddressNoDetailInvalidMessage = (zipCode, address, isRequired = true) => {
	if (isRequired && (!zipCode || !address)) return '주소를 입력해주세요.';
	return '';
};

export const getExportNameInvalidMessage = (status, name, isRequired = true) => {
	if (status === 'Y' && isRequired && !name) return '수출업체 상호명을 입력해주세요.';
	return '';
};

export const getExportAddressInvalidMessage = (status, zipCode, address, isRequired = true) => {
	if (status === 'Y' && isRequired && (!zipCode || !address)) {
		return '수출업체 주소를 입력해주세요.';
	}
	return '';
};

export const getExportTelInvalidMessage = (status, value, isRequired = true) => {
	if (status === 'Y' && isRequired && !value) return '수출업체 전화번호를 입력해주세요.';
	if (status === 'Y' && value && (value.length < 9 || value.length > 12)) return '번호 형식이 올바르지 않습니다.';
	if (status === 'Y' && value && (!testNumber(value) || !testTel(value))) return '번호 형식이 올바르지 않습니다.';
	return '';
};

export const getAssociationInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '조합명을 선택해주세요.';
	return '';
};

export const getFirmNameInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '상사 상호명을 입력해주세요.';
	return '';
};

export const getBusinessNumberInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '사업자번호를 입력해주세요.';
	if (value && !testNumber(value)) return '숫자만 입력해주세요.';
	return '';
};

export const getFaxInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '팩스번호를 입력해주세요.';
	if (value && !testNumber(value)) return '숫자만 입력해주세요.';
	return '';
};

export const getSalesInvalidMessage = (value, isRequired = true) => {
	if (isRequired && !value) return '매매사원증번호를 입력해주세요.';
	if (value && !testSalesNumber(value)) return '한글, 영문, 숫자, -만 입력할 수 있습니다.';
	return '';
};

export const isValidBirthCheck = (value) => {
	if (value && !dayjs(value, MEMBER_BIRTH_FORM_DATE_FORMAT, true).isValid()) return false;
	return true;
};
